import { createAction, props } from "@ngrx/store";
import { ISkillNode } from "@skills-app/models/skillNode";

const prefix = "[Edit Skill]";

export const requestEditSkill = createAction(
  `${prefix} Request Edit Skill`,
  props<{ skill: ISkillNode }>(),
);

export const requestForceEditSkill = createAction(
  `${prefix} Request Force Edit Skill`,
  props<{ skill: ISkillNode }>(),
);
